import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import { toastError, toastWarn } from "../../../common/Toast";
import CurrencySymbols from "../../../common/CurrencySymbol";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const SaleByEmployee = (props) => {
  const {
    isManageSale,
    isManagePOSSale,
    ReportViewPermission,
    currencySymbolLocation,
    dateFormate,
  } = useContext(AppContext);
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  let PERMISSION_EDIT = "/manage-sales/:id";
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let PERMISSION_SHOW_PROFIT_PRICE = "show-profit-price";
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [employeeDropdown, setemployeeDropdown] = useState([]);
  const [employeeid, setemployeeid] = useState(0);
  const [employeeName, setEmployeeName] = useState("");
  const [showList, setShowList] = useState([]);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );
  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });

  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);

    if (selectReport === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3)
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  const apicall = () => {
    setResponseData([]);
    setShowList([]);
    setTotalData({
      TotalSum: 0,
      SubTotalSum: 0,
      TaxSum: 0,
      CostOfGoodsSoldSum: 0,
      ProfitSum: 0,
    });
    // if (employeeid === 0 || employeeid === undefined) {
    //   toastError("Please Select an employee to get report");
    //   return;
    // }
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/salebyemployee?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&employeeid=${employeeid}&saletype=${salesTypeID}&locationid=${selectedlocationid}
          `,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          const apiData = res.data.ResponseData;
          if (res.data.ResponseData.length > 0) {
            setTotalData({
              ...totalData,
              TotalSum: apiData.reduce(
                (sum, item) => sum + (parseFloat(item.Total) || 0),
                0
              ),
              SubTotalSum: apiData.reduce(
                (sum, item) => sum + (parseFloat(item.SubTotal) || 0),
                0
              ),
              TaxSum: apiData.reduce(
                (sum, item) => sum + (parseFloat(item.Tax) || 0),
                0
              ),
              CostOfGoodsSoldSum: apiData.reduce(
                (sum, item) => sum + (parseFloat(item.CostOfGoodsSold) || 0),
                0
              ),
              ProfitSum: apiData.reduce(
                (sum, item) => sum + (parseFloat(item.Profit) || 0),
                0
              ),
            });

            setLoading(false);
          } else {
            toastWarn("No Records found!");
            setTotalData({
              ...totalData,
              TotalSum: 0,
              SubTotalSum: 0,
              TaxSum: 0,
              CostOfGoodsSoldSum: 0,
              ProfitSum: 0,
            });
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        toastError("Something went wrong!");
        console.log(err);
        setLoading(false);
        return;
      });
  };

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     employeeid + " employeeid",
  //     salesTypeID + " saletype",
  //     locationid + " locationid",

  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/salebyemployee?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}&employeeid=${employeeid}&saletype=${salesTypeID}&locationid=${locationid}
  //         `,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )

  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         setData(res.data.ResponseData);
  //         if (res.data.ResponseData.length > 0) {
  //           setRowCount(res.data.ResponseData[0].TotalRecord);
  //           setTotalData({
  //             ...totalData,
  //             TotalSum: res.data.ResponseData[0].TotalSum,
  //             SubTotalSum: res.data.ResponseData[0].SubTotalSum,
  //             TaxSum: res.data.ResponseData[0].TaxSum,
  //             CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
  //             ProfitSum: res.data.ResponseData[0].ProfitSum,
  //           });
  //         } else {
  //           setRowCount(0);
  //           setTotalData({
  //             ...totalData,
  //             TotalSum: 0,
  //             SubTotalSum: 0,
  //             TaxSum: 0,
  //             CostOfGoodsSoldSum: 0,
  //             ProfitSum: 0,
  //           });
  //         }
  //         //   barcodeRefs.current = responseData;
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   locationid,
  //   employeeid,
  //   salesTypeID,
  // ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/employeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("employee", res);
        setemployeeDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Sale Id",
      accessorKey: "SaleID",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          })}
          onClick={() => {
            const url =
              isManageSale == 1
                ? `/manage-sales/${row.original.SaleID}`
                : isManagePOSSale
                ? `/pos/${row.original.SaleID}`
                : "#";
            if (checkUserPermission(PERMISSION_EDIT)) {
              window.open(url);
            }
          }}
        >
          {row.original.SaleID}
        </Box>
      ),
    },
    {
      header: "Location",
      accessorKey: "Loacation",
      filterFn: "contains",
    },
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return Date.format("MM/DD/YYYY");
        } else {
          return "";
        }
      },
    },
    {
      header: "Register",
      accessorKey: "Register",
    },
    {
      header: "Items Purchased",
      accessorKey: "ItemPurchased",
      filterFn: "contains",
    },
    {
      header: "Sold By",
      accessorKey: "Employee",
      filterFn: "contains",
    },
    {
      header: "Sold To",
      accessorKey: "SoldTo",
      filterFn: "contains",
    },
    {
      header: "Subtotal",
      accessorKey: "SubTotal",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.SubTotal),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      // enableSorting: false,
    },
    {
      header: "Total",
      accessorKey: "Total",
      filterFn: "contains",
      // enableSorting: false,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Total),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Tax),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    // {
    //   header: "Profit",
    //   accessorKey: "Profit",
    //   filterFn: "contains",
    //   Cell: ({ row }) => {
    //     return (
    //       <div style={{ textAlign: "end" }}>
    //         {CurrencySymbols(
    //           Number(row.original.Profit),
    //           { CurrencySymbol },
    //           FractionDigits
    //         )}
    //       </div>
    //     );
    //   },
    //   hidden:
    //     checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) == true
    //       ? true
    //       : false,
    // },

    {
      header: "Cost Of Goods Sold",
      accessorKey: "CostOfGoodsSold",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.CostOfGoodsSold),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      hidden:
        checkUserPermission(PERMISSION_SHOW_COST_PRICE) == true ? true : false,
    },
    {
      header: "Payment Type",
      accessorKey: "PaymentType",
      filterFn: "contains",
    },
    {
      header: "Comments",
      accessorKey: "Comments",
      filterFn: "contains",
    },
    {
      header: "Discount Reason",
      accessorKey: "DiscountReason",
      filterFn: "contains",
    },
  ]);

  const Classiccolumns = [
    // {
    //   title: "Transaction Type",
    //   field: "TransactionType",
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   formatter: (cell) => {
    //     const data = cell.getRow().getData();
    //     const span = document.createElement("span");

    //     span.textContent = data.TransactionType || "";
    //     span.style.borderRadius = "0.3rem";
    //     span.style.color = "#343f62";
    //     span.style.maxWidth = "18ch";
    //     span.style.textDecoration = "underline";
    //     span.style.textUnderlineOffset = "3px";
    //     span.style.padding = "0.3rem";
    //     span.style.cursor = "pointer";
    //     span.style.display = "flex";
    //     span.style.alignItems = "center";
    //     span.style.overflow = "hidden";
    //     span.style.whiteSpace = "nowrap";
    //     span.style.textOverflow = "ellipsis";

    //     span.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       const saleId = data.ID;
    //       let url = `/receiving-receipt/${saleId}`; // default

    //       url = `/receiving-receipt/${saleId}`;

    //       window.open(url, "_blank");
    //     });

    //     return span;
    //   },
    // },
    {
      title: "SaleID",
      field: "SaleID",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
      formatter: function (cell) {
        const rowData = cell.getRow().getData();
        const saleId = rowData.SaleID || "";
        let url = "#";
        if (isManageSale == 1) {
          url = `/manage-sales/${saleId}`;
        } else if (isManagePOSSale) {
          url = `/pos/${saleId}`;
        }
        return `<span style="color:#343f62;font-weight:700;text-decoration:underline;cursor:pointer;" onclick="window.open('${url}', '_blank')">${saleId}</span>`;
      },
    },
    {
      title: "Loacation",
      field: "Loacation",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()}`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Register",
      field: "Register",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Item Purchased",
      field: "ItemPurchased",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Sold By",
      field: "Employee",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Sold To",
      field: "SoldTo",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    // {
    //   title: "Total Number Of Items",
    //   field: "TotalNumberOfItems",
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   // frozen: true,
    //   formatter: function (cell) {
    //     const value = cell.getValue();
    //     // Format to 2 decimal places, but only if it's a number
    //     return typeof value == "number"
    //       ? value.toFixed(2)
    //       : Number(value).toFixed(2);
    //   },
    // },
    {
      title: "Sub Total",
      field: "SubTotal",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total",
      field: "Total",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Tax",
      field: "Tax",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Cost Of Goods Sold",
      field: "CostOfGoodsSold",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Payment Type",
      field: "PaymentType",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Comments",
      field: "Comments",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Discount Reason",
      field: "DiscountReason",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
  ];

  const handleChangeSalesType = (event) => {
    console.log(event, "handleChangeSalesType");
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const handleChangeEmployee = (event) => {
    console.log(event, "handleChangeEmployee");
    setemployeeid(event?.value);
    setEmployeeName(event?.label);
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  let dashStyle = {
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const handleShowItemsData = (saleId, employeeId) => {
    axios
      .get(
        // `${config.reportsBaseUrl}/reports/showsaleitemsbyid?saleid=${saleId}&isSaleItem=${isSaleItem}&itemids=${ItemIds}`,
        `${config.reportsBaseUrl}/reports/showsaleitemsbyid?saleid=${saleId}&issaleitem=0&itemids=0&employeeId=${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("ShowList======>", res);
        setShowList(res.data.ResponseData);
        return res;
      });
  };

  const renderDetailPanel = () => (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Item Number</TableCell>
            <TableCell>ProductID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Current Selling Price</TableCell>
            <TableCell>Quantity Sold</TableCell>
            <TableCell>Subtotal</TableCell>
            <TableCell>Total</TableCell>
            {checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) && (
              <TableCell>Profit </TableCell>
            )}
            {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
              <TableCell>Cost Price </TableCell>
            )}
            <TableCell>Discount</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {showList.map((row) => (
            <TableRow
              key={row.name}
              // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>{row.ItemNumber}</TableCell>
              <TableCell>{row.ProductId}</TableCell>
              <TableCell>{row.ItemName}</TableCell>
              <TableCell>{row.Category}</TableCell>
              <TableCell>{row.CurrentSellingPrice}</TableCell>
              <TableCell>{row.QuantitySold}</TableCell>
              <TableCell>{row.Subtotal}</TableCell>
              <TableCell>{row.Total}</TableCell>
              {checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) && (
                <TableCell>{row.Profit}</TableCell>
              )}
              {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
                <TableCell>{row.CostPrice}</TableCell>
              )}
              <TableCell>{row.Discount}</TableCell>
              <TableCell>{row.Size}</TableCell>
              <TableCell>{row.Description}</TableCell>
              {/* <TableCell align="right">{row.Size}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    // </Box>
  );

  const processedSaleIds = new Set();

  const muiExpandButtonProps = ({ row, table }) => {
    console.log(row, table, "rowtabledata");

    const saleId = row.original.SaleID;
    const employeeId = row.original.EmployeeID;
    return {
      onClick: () => {
        // Check if this SaleId has already been processed
        if (!processedSaleIds.has(saleId)) {
          // Call your function
          handleShowItemsData(saleId, employeeId);

          // Mark this SaleId as processed
          processedSaleIds.add(saleId);
        }

        // Set only this row to be expanded
        table.setExpanded({ [row.id]: !row.getIsExpanded() });
      },
    };
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Detailed Employees Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-3">
                Employee
                <span className="text-danger">*</span>
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    options={employeeDropdown.map((employee) => ({
                      label: employee.Name,
                      value: employee.Id,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeEmployee(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.SubTotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.SubTotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TaxSum} */}
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.ProfitSum} */}
                        {CurrencySymbols(
                          Number(totalData.ProfitSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.CostOfGoodsSoldSum} */}
                        {CurrencySymbols(
                          Number(totalData.CostOfGoodsSoldSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Cost Of Goods Sold</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">
                        {employeeName != "" ? employeeName : "All Employees"}{" "}
                        Report
                      </p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format("MM/DD/YYYY") +
                              " - " +
                              moment(enddate).format("MM/DD/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      {ReportViewPermission == true ? (
                        <button
                          className="btn btn-secondary"
                          onClick={() => setClassicView(!classicView)}
                        >
                          {" "}
                          {classicView ? "Classic View" : "Morden View"}
                        </button>
                      ) : (
                        <></>
                      )}

                      {classicView ? (
                        <CommonTabular
                          Data={responseData}
                          columns={Classiccolumns}
                          Groupvalue={[]}
                          Reportname="Detailed Employees Report"
                          frozenRowvalue={0}
                          layout="fitDataFill"
                          Onrefresh={() => apicall()}
                          handleShowItemsData={async (saleId, employeeId) => {
                            const res = await fetch(
                              `${config.reportsBaseUrl}/reports/showsaleitemsbyid?saleid=${saleId}&issaleitem=0&itemids=0&employeeId=${employeeId}`,
                              {
                                headers: {
                                  "Content-Type":
                                    "application/json;charset=UTF-8",
                                  Authorization: token,
                                },
                              }
                            );
                            const json = await res.json();
                            return json.ResponseData;
                          }}
                          isSubTable={true}
                        />
                      ) : (
                        <CommonMatrialReactTable
                          MainHeading="Sonar POS"
                          ReportHeading="Detailed Employees Report"
                          columns={columns}
                          data={responseData}
                          startdate={startdate}
                          enddate={enddate}
                          columnGrouping={[]}
                          columnsVisibility={{}}
                          renderDetailPanel={renderDetailPanel}
                          muiExpandButtonProps={muiExpandButtonProps}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SaleByEmployee;
